module.exports = require("@wordpress/dom-ready");